import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { k as t, f as n } from "../../../../chunks/vec2.js";
import { a as e } from "../../../../chunks/vec2f64.js";
import { LineConstraint as i } from "../SnappingConstraint.js";
import { SnappingCandidate as s } from "./SnappingCandidate.js";
import { LineSnappingHint as r } from "../hints/LineSnappingHint.js";

var o = /*#__PURE__*/function (_s) {
  _inherits(o, _s);

  var _super = _createSuper(o);

  function o(_ref) {
    var _this;

    var t = _ref.coordinateHelper,
        n = _ref.lineStart,
        e = _ref.lineEnd,
        s = _ref.targetPoint;

    _classCallCheck(this, o);

    _this = _super.call(this, t, s, new i(t, n, e)), _this.referenceLineHint = new r(2, n, e);
    return _this;
  }

  _createClass(o, [{
    key: "hints",
    get: function get() {
      return [this.referenceLineHint, new r(0, this.lineEndClosestToTarget(), this.targetPoint)];
    }
  }, {
    key: "lineEndClosestToTarget",
    value: function lineEndClosestToTarget() {
      var e = this.constraint.start,
          i = this.constraint.end;
      return Math.sign(t(n(c, i, e), n(a, this.targetPoint, e))) > 0 ? i : e;
    }
  }]);

  return o;
}(s);

var a = e(),
    c = e();
export { o as LineSnappingCandidate };